module.exports = __webpack_public_path__ + "img/8.4a1409cb.jpg";